/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Country, getCountries, getCountryCallingCode, isSupportedCountry } from "react-phone-number-input";
import { FormFieldProps, OptionProps } from "../fields";
import en from 'react-phone-number-input/locale/en.json';
import { DEFAULT_COUNTRY, hasValue } from "@r-and-a-shared-ui/utils";

export const getDefaultCountryCode = (formCountry: any, countries: OptionProps[] | undefined) => {
  const kontentCountryCode = hasValue(formCountry?.code)
    ? formCountry?.code?.toUpperCase()
    : hasValue(formCountry)
      ? formCountry.toUpperCase()
      : DEFAULT_COUNTRY;

  if (isSupportedCountry(kontentCountryCode)) {
    return kontentCountryCode;
  }

  const kontentPrefix = hasValue(formCountry?.internationalCodePrefix)
    ? formCountry.internationalCodePrefix
    : (countries?.find(c => c.value === kontentCountryCode) as any)?.internationalCodePrefix;
  const callingCode = kontentPrefix?.replace('+', '');
  const libraryCountryCode = getCountries().find(c => getCountryCallingCode(c) === callingCode);
  if (libraryCountryCode) {
    return libraryCountryCode;
  }

  return DEFAULT_COUNTRY;
};

export const getDialCode = (value: Country | undefined) => {
  if (value) {
    return "+" + getCountryCallingCode(value);
  }

  return "";
};

export const getCountryOptionsOrder = (options: OptionProps[] | undefined): any[] => {
  const countryOptionsOrder: any[] = [];
  options?.forEach(option => {
    if (option?.value) {
      countryOptionsOrder.push(option?.value.toUpperCase());
    }
  });
  countryOptionsOrder.push('|');
  countryOptionsOrder.push('...');
  return countryOptionsOrder;
};

export const getFlags = (countryField: FormFieldProps): any => {
  if (countryField) {
    const flags = countryField.options?.reduce((obj, item) => {
      // @ts-ignore
      obj[item.code.toUpperCase()] = () => <img src={item.flagUrl} alt={item.code}/>;
      return obj;
    }, {});
    return flags;
  }
};

export const getLabels = (countryField: FormFieldProps): any => {
  if (countryField) {
    const labels = countryField?.options?.reduce((obj, item) => {
      // @ts-ignore
      obj[item.code.toUpperCase()] = item.label;
      return obj;
    }, en);
    return labels;
  }
};